export enum COMMON_CURRENCY {
  czk = 'CZK',
  cze = 'CZE',
  aut = 'AUT',
  eur = 'EUR',
  huf = 'HUF',
  deu = 'DEU',
}
